import { IAppState } from '../../common/state';
import { getCurrentRegionId } from '../getCurrentRegionId';

export function getNewbuildingEntryAdPath(state: IAppState): string {
  if (state.newbuildingAdPath) {
    return state.newbuildingAdPath;
  }

  const regionId = getCurrentRegionId(state);
  const search = new URLSearchParams('deal_type=sale&engine_version=2&offer_type=flat&object_type%5B0%5D=2');
  search.set('region', String(regionId || -1));

  return '/cat.php?' + search.toString();
}
